import { useContext } from "react";

import { ApplicationInsightsContext } from "../../contexts/application-insights";

export const useApplicationInsights = () => {
	return useContext(ApplicationInsightsContext);
};
